import axios from '../api/axios';
import useAuth from './useAuth';
import { useQueryClient } from '@tanstack/react-query';
import { useSelections } from '../context/SelectionsProvider';
import { useNavigate } from 'react-router-dom';

const useLogout = () => {
    const {setAuth} = useAuth();
    const { setSelectedOrgID, setSelectedSiteID, setSelectedTabName } = useSelections();
    const queryClient = useQueryClient();

    const logout = async () => {
        setAuth({});
        setSelectedOrgID('');
        setSelectedSiteID('');
        setSelectedTabName('');

        await queryClient.cancelQueries();
        queryClient.clear();

        try{
            const response = await axios('/auth/logout', {
                withCredentials: true
            });
        }catch(err){
            console.error(err)
        }
    }
    
    return logout;
}

export default useLogout;